import store from '@/store'

export default {
  computed: {
    extensionsWidgets () {
      return store.getters['extensions/getWidgets'](this.$options.name)
    }
  }
}
